module.exports = __webpack_public_path__ + "img/download1.eebe77e8.png";